import { render, staticRenderFns } from "./BandejaFechaTextoCobroPtiComponente.vue?vue&type=template&id=46cdb318"
import script from "./BandejaFechaTextoCobroPtiComponente.vue?vue&type=script&lang=js"
export * from "./BandejaFechaTextoCobroPtiComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports